module.exports = __webpack_public_path__ + "static/gate-2db47152b00fdbd5f4689fccd7f28a16.jpg";